import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Remet automatiquement la position de défilement en haut de page à chaque
 * changement de route. Respecte les liens à ancre (#section) : dans ce cas
 * le navigateur gère lui-même le scroll vers l'élément ciblé.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Si un hash est présent, laisser le comportement natif d'ancre agir
    if (hash) return;
    // Utilise "instant" (Chrome 97+) sinon "auto" pour compat maximale
    try {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    } catch (_) {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}
